import { handleSearchClick, setSelectedRows, setSelectMode } from 'actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { setSelectedClips } from 'slices/clips.slice';
import { applyCollectionFilters } from 'slices/collection.slice';
import { changePage } from 'slices/pagination.slice';
import { toggleReloadLibrary } from 'slices/toggle.slice';
import { isSemanticBrowse, validPageSize } from 'utils/libraryPagination.util';

/**
 * If the mode changes without a fetch, the list on screen belongs to the
 * other mode. A pagination or sort action taken then is a search in the new
 * mode: it submits the typed text and applies the collection filters, like
 * the Search button (Sort.tsx triggerSearch), instead of reusing the last
 * search's text.
 */
export const useModeSwitchSearch = () => {
  const dispatch = useDispatch();
  const advancedSearch = useSelector(
    (state: RootState) => state.advancedSearch,
  );
  const pageSize = useSelector(
    (state: RootState) => state.pagination.page_size,
  );

  const { isSemanticSearch, fetchedIsSemanticSearch } = advancedSearch;
  const isModeSwitched =
    fetchedIsSemanticSearch !== null &&
    fetchedIsSemanticSearch !== isSemanticSearch;

  const searchInNewMode = (nextPageSize: number = pageSize) => {
    dispatch(applyCollectionFilters());
    dispatch(handleSearchClick(advancedSearch.librarySearchInput));
    dispatch(
      changePage({
        page_number: 1,
        page_size: validPageSize(
          nextPageSize,
          isSemanticSearch,
          isSemanticBrowse(
            advancedSearch.librarySearchInput,
            advancedSearch.searchParams.searchBy,
          ),
        ),
      }),
    );
    dispatch(setSelectedRows([]));
    dispatch(setSelectedClips([]));
    dispatch(setSelectMode(false));
    // Refetch even when the text, page and size are unchanged.
    dispatch(toggleReloadLibrary());
  };

  return { isModeSwitched, searchInNewMode };
};
